import React from 'react';

const Team = () => {
  return (
    <div className="team-page" data-testid="team-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">Nuestro Equipo</h1>
          <p className="hero-subtitle body-large">
            Staff profesional altamente calificado y comprometido con tu bienestar
          </p>
        </div>
      </section>

      {/* Psychologists Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Psicólogos - Psicoterapeutas</h2>
          </div>

          <div className="team-grid">
            {/* Psychologist 1 - José Luis Riojas Luna */}
            <div className="team-member-card">
              <div className="member-photo-container">
                <img 
                  src="https://centropsicologicobiocalm.com/wp-content/uploads/2021/09/fo1.jpg" 
                  alt="Lic. José Luis Riojas Luna"
                  className="member-photo"
                  loading="lazy"
                />
              </div>
              <div className="member-info">
                <h3 className="heading-3">Lic. José Luis Riojas Luna</h3>
                <p className="member-registration caption">C.Ps.P N° 27935</p>
                <ul className="member-specialties">
                  <li className="body-small">Psicoterapia Cognitivo Conductual</li>
                  <li className="body-small">Tratamiento en trastornos de personalidad</li>
                  <li className="body-small">Hipnosis clínica</li>
                  <li className="body-small">Terapia de modificación de conducta en niños y adolescentes</li>
                  <li className="body-small">Terapia familiares y de pareja</li>
                  <li className="body-small">Psicología Forense</li>
                  <li className="body-small">Consultor en Psicología Organizacional</li>
                  <li className="body-small">Conciliador Extrajudicial</li>
                </ul>
              </div>
            </div>

            {/* Psychologist 2 - Rocío del Carmen Alarcón Aguilar */}
            <div className="team-member-card">
              <div className="member-photo-container">
                <img 
                  src="https://centropsicologicobiocalm.com/wp-content/uploads/2021/09/f2.jpg" 
                  alt="Lic. Rocío del Carmen Alarcón Aguilar"
                  className="member-photo"
                  loading="lazy"
                />
              </div>
              <div className="member-info">
                <h3 className="heading-3">Lic. Rocío del Carmen Alarcón Aguilar</h3>
                <p className="member-registration caption">C.Ps.P N° 31419</p>
                <ul className="member-specialties">
                  <li className="body-small">Psicoterapia Cognitivo Conductual</li>
                  <li className="body-small">Terapia Racional Emotiva (TREC)</li>
                  <li className="body-small">Atención a pacientes mediante lenguaje de señas</li>
                  <li className="body-small">Psicoterapia en temas de Violencia Familiar (niños, jóvenes, adultos)</li>
                  <li className="body-small">Consejería en procesos emocionales sobre Infertilidad</li>
                  <li className="body-small">Psicología del Adulto Mayor</li>
                </ul>
              </div>
            </div>

            {/* Psychologist 3 - Graciela Jara Ramirez */}
            <div className="team-member-card">
              <div className="member-photo-container">
                <img 
                  src="https://centropsicologicobiocalm.com/wp-content/uploads/2021/12/JaraGrac.jpg" 
                  alt="Lic. Graciela Jara Ramirez"
                  className="member-photo"
                  loading="lazy"
                />
              </div>
              <div className="member-info">
                <h3 className="heading-3">Lic. Graciela Jara Ramirez</h3>
                <p className="member-registration caption">C.Ps.P N° 37860</p>
                <ul className="member-specialties">
                  <li className="body-small">Psicoterapeuta Cognitivo Conductual Emotivo (TREC)</li>
                  <li className="body-small">Especialidad en trastornos del neurodesarrollo TEA y problemas de lenguaje y comunicación</li>
                  <li className="body-small">Modificación de conducta y psicoeducación de emociones niños adolescentes y orientación para padres</li>
                  <li className="body-small">Diagnóstico y abordaje cognitivo conductual en trastornos de la conducta alimentaria</li>
                  <li className="body-small">Terapia Dialéctica Conductual (DBT)</li>
                </ul>
              </div>
            </div>

            {/* Psychologist 4 - Ducy Figueroa Fernandez */}
            <div className="team-member-card">
              <div className="member-photo-container">
                <img 
                  src="https://centropsicologicobiocalm.com/wp-content/uploads/2023/03/DUCY.png" 
                  alt="Lic. Ducy Figueroa Fernandez"
                  className="member-photo"
                  loading="lazy"
                />
              </div>
              <div className="member-info">
                <h3 className="heading-3">Lic. Ducy Figueroa Fernandez</h3>
                <p className="member-registration caption">C.Ps.P N° 27903</p>
                <ul className="member-specialties">
                  <li className="body-small">Psicoterapeuta cognitivo conductual</li>
                  <li className="body-small">Psicoterapeuta en Terapia Racional Emotiva</li>
                  <li className="body-small">Segunda Especialización en Psicología Clínica de la Salud</li>
                  <li className="body-small">Estudios de Maestría en Gerencia de Servicios de Salud</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <h2 className="heading-1">Sobre Mind Life</h2>
            <div className="about-text">
              <p className="body-large">
                Mind Life es un centro psicológico especializado en brindar atención integral 
                en salud mental. Nuestro equipo multidisciplinario está conformado por profesionales 
                certificados con amplia experiencia en diversas áreas de la psicología.
              </p>
              <p className="body-medium">
                Nos comprometemos a ofrecer un espacio seguro, confidencial y acogedor donde 
                cada persona pueda trabajar en su bienestar emocional y desarrollo personal. 
                Utilizamos enfoques terapéuticos basados en evidencia científica, adaptados 
                a las necesidades específicas de cada paciente.
              </p>
              <p className="body-medium">
                Atendemos a niños, adolescentes, adultos y adultos mayores, ofreciendo desde 
                terapia individual hasta intervenciones familiares, evaluaciones neuropsicológicas 
e interconsultas psiquiátricas cuando son necesarias.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Conoce a Nuestro Equipo</h2>
            <p className="body-large">
              Agenda una cita y descubre cómo podemos acompañarte en tu proceso.
            </p>
            <a
              href="https://wa.me/51934442759"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary large"
            >
              CONTACTAR AHORA
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;